import { Icon } from "@mui/material";
import clsx from "clsx";
import React, { useState } from "react";
import { IColuna } from "../../../types/IColuna";
import { HeaderConsultarItens } from "./HeaderConsultarItens";
import { MenuColunasConsultarItens } from "./MenuColunasConsultarItens";

const estiloModalConsultarItens =
  require("../consultar-itens.module.scss").default;

export type TableHeadConsultarItensProps = {
  onAlterarFonte: (tamanho: number) => void;
  tamanhoFonte: number;
  colunas: IColuna[];
  onToggleColunaSelecionada: (colunas: IColuna[]) => void;
};

export const TableHeadConsultarItens = (
  props: TableHeadConsultarItensProps
) => {
  const [mostrarFerramentas, setMostrarFerramentas] = useState<boolean>(false);
  const [icon, setIcon] = useState<string>("arrow_drop_up");

  const menuColunas = (
    <div className="no-global-button">
      <MenuColunasConsultarItens
        colunas={props.colunas}
        onToggleColunaSelecionada={props.onToggleColunaSelecionada}
      />
    </div>
  );

  const botoesAumentarDiminuirFonte = (
    <div className="_flex _flex-row _mt-1 _gap-x-2">
      <button
        className={clsx("no-global-button", estiloModalConsultarItens.gridButton)}
        onClick={() => props.onAlterarFonte(props.tamanhoFonte + 1)}
        disabled={props.tamanhoFonte >= 26}
      >
        A+
      </button>
      <button
        className={clsx("no-global-button", estiloModalConsultarItens.gridButton)}
        onClick={() => props.onAlterarFonte(props.tamanhoFonte - 1)}
        disabled={props.tamanhoFonte <= 8}
      >
        A-
      </button>
    </div>
  );

  const iconeExibirEsconderOpcoes = (
    <button
      style={{ padding: "6px, 12px" }}
      id="table-head__grid-itens__arrow"
      className="no-global-button"
      onClick={() => {
        setMostrarFerramentas(!mostrarFerramentas);
        setIcon(icon == "arrow_drop_up" ? "arrow_drop_down" : "arrow_drop_up");
      }}
    >
      <Icon>{icon}</Icon>
    </button>
  );

  return (
    <>
      <thead>
        <tr>
          <th
            colSpan={props.colunas?.length + 2}
            style={{
              textAlign: "left",
            }}
          >
            {iconeExibirEsconderOpcoes}

            {mostrarFerramentas && (
              <div style={{ marginBottom: "5px" }}>
                {menuColunas}

                {botoesAumentarDiminuirFonte}
              </div>
            )}
          </th>
        </tr>

        <HeaderConsultarItens colunas={props.colunas} />
      </thead>
    </>
  );
};
